import { memo } from 'react';
import { Outlet } from 'react-router-dom';
import { Card, CardContent } from 'components/ui/card';
const NewsPage = memo(() => {
  return (
    <Card className="max-w-3xl mx-auto my-8">
      <CardContent>
        <h2 className="text-2xl font-bold mb-4">Новости</h2>
        <Outlet />
      </CardContent>
    </Card>
  );
});

export default NewsPage;
